var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import styled from "styled-components";
import Lozenge from '@atlaskit/lozenge';
import ChevronRightCircleIcon from '@atlaskit/icon/glyph/chevron-right-circle';
import ChevronDownCircleIcon from '@atlaskit/icon/glyph/chevron-down-circle';
import DynamicTable from '@atlaskit/dynamic-table';
import classnames from 'classnames';
import moment from 'moment';
var CredoContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 15px;\n  border-radius: 5px;\n  background-color: #EBECF0;\n  display: flex;\n  flex-direction: column;\n\n  &.has-hover {\n    background-color: #d7d9de;\n    cursor: pointer;\n  }\n"], ["\n  padding: 15px;\n  border-radius: 5px;\n  background-color: #EBECF0;\n  display: flex;\n  flex-direction: column;\n\n  &.has-hover {\n    background-color: #d7d9de;\n    cursor: pointer;\n  }\n"])));
var CredoHeader = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"])));
var CredoStatus = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"])));
var Status = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-left: 10px;\n"], ["\n  padding-left: 10px;\n"])));
var CredoTitle = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  >:first-child {\n    margin-right: 10px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  >:first-child {\n    margin-right: 10px;\n  }\n"])));
var CredoTier = styled.h4(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  margin-left: 40px;\n  color: black !important;\n"], ["\n  margin-left: 40px;\n  color: black !important;\n"])));
var SOC2 = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-left: 40px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin-left: 40px;\n"])));
var CredoBody = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  color: black;\n  cursor: auto;\n  margin-top: 15px;\n  padding: 15px 20px 0 20px;\n  background-color: #FAFBFC;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow-wrap: break-word;\n"], ["\n  color: black;\n  cursor: auto;\n  margin-top: 15px;\n  padding: 15px 20px 0 20px;\n  background-color: #FAFBFC;\n  border-radius: 5px;\n  display: flex;\n  flex-direction: column;\n  overflow-wrap: break-word;\n"])));
export var getStatus = function (status) {
    switch (status.toUpperCase()) {
        case "PENDING":
            return { label: "PENDING", appearance: "new" };
        case "IN_PROGRESS":
            return { label: "IN PROGRESS", appearance: "inprogress" };
        case "WON'T_DO":
            return { label: "WON'T DO", appearance: "inprogress" };
        case "NOT_APPLICABLE":
            return { label: "NOT APPLICABLE", appearance: "inprogress" };
        case "IN_REVIEW":
            return { label: "IN REVIEW", appearance: "inprogress" };
        case "DONE":
        case "COMPLETED":
            return { label: "DONE", appearance: "success" };
        case "REJECTED":
            return { label: "REJECTED", appearance: "success" };
        case "RISK_ACCEPTED":
            return { label: "RISK ACCEPTED", appearance: "success" };
        case "FAILED":
            return { label: "FAILED", appearance: "removed" };
        default:
            return { label: status, appearance: "default" };
    }
};
var head = {
    cells: [
        {
            key: 'credoTask',
            content: 'Credo Task',
            shouldTruncate: true,
            width: 18
        },
        {
            key: 'tier',
            content: 'Tier',
            width: 15
        },
        {
            key: 'updated',
            content: 'Updated',
            width: 20
        },
        {
            key: 'status',
            content: 'Status',
            width: 16
        }
    ]
};
var credoTasksToRows = function (tasks) { return (tasks.map(function (task) { return ({
    key: task.key,
    cells: [
        {
            key: 'credoTask',
            content: (React.createElement("a", { href: "https://ops.internal.atlassian.com/jira/browse/" + task.key, target: "_blank", rel: "noopener noreferrer", onClick: function (e) { return e.stopPropagation(); } }, task.summary.replace('CLONE - ', '')))
        },
        {
            key: task.tier,
            content: "Tier " + task.tier
        },
        {
            key: 'updated',
            content: moment(task.updatedAt).fromNow()
        },
        {
            key: 'status',
            content: (React.createElement(Lozenge, { appearance: getStatus(task.status).appearance }, getStatus(task.status).label))
        }
    ]
}); })); };
var Credo = function (_a) {
    var credo = _a.credo, isOpen = _a.isOpen;
    var _b = useState({
        isOpen: isOpen || false,
        hasHover: false
    }), credoState = _b[0], setCredoState = _b[1];
    var handleMouseOver = function () {
        setCredoState(__assign(__assign({}, credoState), { hasHover: true }));
    };
    var handleMouseOut = function () {
        setCredoState(__assign(__assign({}, credoState), { hasHover: false }));
    };
    var toggleCollapse = function () {
        setCredoState(__assign(__assign({}, credoState), { isOpen: !credoState.isOpen }));
    };
    return (React.createElement(CredoContainer, { onMouseOver: handleMouseOver, onMouseOut: handleMouseOut, onClick: toggleCollapse, className: classnames('service', { collapsed: !credoState.isOpen }, { 'has-hover': credoState.hasHover }) },
        React.createElement(CredoHeader, null,
            React.createElement(CredoTitle, null,
                credoState.isOpen ?
                    React.createElement(ChevronDownCircleIcon, { size: "small", label: "expanded" }) :
                    React.createElement(ChevronRightCircleIcon, { size: "small", label: "collapsed" }),
                React.createElement("div", null,
                    React.createElement("h4", null,
                        React.createElement("a", { href: "https://ops.internal.atlassian.com/jira/browse/" + credo.key, target: "_blank", rel: "noopener noreferrer", onClick: function (e) { return e.stopPropagation(); } }, "" + credo.key.toUpperCase()))),
                React.createElement("div", null,
                    React.createElement(CredoTier, null,
                        "Tier ",
                        credo.tier)),
                credo.soc2 &&
                    React.createElement(SOC2, null,
                        React.createElement(Lozenge, { appearance: "new", isBold: true }, "SOC2"))),
            React.createElement(CredoStatus, null,
                React.createElement(Status, null,
                    React.createElement(Lozenge, { appearance: getStatus(credo.status).appearance, isBold: true }, getStatus(credo.status).label)))),
        credoState.isOpen &&
            React.createElement(CredoBody, { onClick: function (e) { return e.stopPropagation(); } },
                React.createElement(DynamicTable, { head: head, rows: credoTasksToRows(credo.children ? credo.children : []), defaultSortKey: "tier", defaultSortOrder: "DESC", isFixedSize: true }))));
};
export default Credo;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
